import { useState } from "react";

import { IModal } from "../types/modal";

export const useModal = (initialVisibility = false): IModal => {
  const [isModalVisible, setIsModalVisible] = useState(initialVisibility);

  const toggleModalVisibility = () => {
    setIsModalVisible((prev) => !prev);
  };

  return {
    isModalVisible,
    toggleModalVisibility,
  };
};
